<div class="home-page">
    <div class="home-page__float header-part">
        <div class="logo-title">
            <div class="logo">
                <img alt="" src="./assets/media/client-logos/quoc-huy.png">
            </div>
            <div class="title">
                <span>CỔNG ĐĂNG NHẬP TẬP TRUNG</span>
                <span>BỘ GIÁO DỤC ĐÀO TẠO</span>
            </div>
        </div>
    </div>
    <div class="home-page__wrapper" [ngClass]="{'action-form': !isHomeForm}">
        <div class="home-page__wrapper__login">
            <div class="wrap-logo-icon">
                <i class="fas fa-arrow-left btn-back" (click)="backToHomeForm()" *ngIf="!isHomeForm"></i>
                <img alt="" src="../../../assets/media/background-Image/Logo_of_bogiaoduc.png">
                <span>Hệ thống quản trị IOC</span>
            </div>
            <div class="home-form float-form" [ngClass]="{'close-form': !isHomeForm}">
                <div class="home-form__wrapper-button">
                    <button type="submit" class="btn btn-primary link-to-login" (click)="showFormLogin()">
                        <span>Đăng nhập</span>
                    </button>
                    <!-- <button type="submit" class="btn btn-primary link-to-login link-to-sso" (click)="loginSSOAction()">
                        <span>Đăng nhập bằng SSO</span>
                    </button> -->
                </div>
                <a class="link-to-forget" href="https://dichvucong.moet.gov.vn/web/guest/quen-mat-khau">
                    Quên mật khẩu ?
                </a>
            </div>
            <div class="action-form float-form" [ngClass]="{'open-form': !isHomeForm}">
                <form [formGroup]="formHome">
                    <div class="form-group row">
                        <label class="col-lg-3 col-form-label text-alert">Email</label>
                        <div class="col-xl-9">
                            <input type="text" class="form-control form-control-lg form-control-solid"
                                autocomplete="off" formControlName="email"
                                [class.is-invalid]="isControlInvalid('email')"
                                [class.is-valid]="isControlValid('email')" (keyup.enter)="loginAction()" />
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-lg-3 col-form-label text-alert">Mật khẩu</label>
                        <div class="col-xl-9">
                            <input type="{{ showPassWd ? 'text' : 'password'}}"
                                class="form-control form-control-lg form-control-solid" autocomplete="off"
                                formControlName="password" [class.is-invalid]="isControlInvalid('password')"
                                [class.is-valid]="isControlValid('password')" (keyup.enter)="loginAction()" />
                        </div>
                        <i class="far fa-{{showPassWd ? 'eye': 'eye-slash'}} icon-visibility-password"
                            (click)="togglePasswordInput()"></i>
                    </div>
                </form>
                <div class="row">
                    <div class="col-xl-6">
                        <div class="form-check">
                            <label class="checkbox checkbox-lg checkbox-inline">
                                <input type="checkbox" [(ngModel)]="rememberMe" id="check-remember-me"
                                    class="form-check__item__checkbox" />
                                <span></span>
                            </label>
                            <label class="checkbox-title" for="check-remember-me">Nhớ mật khẩu</label>
                        </div>
                    </div>
                    <div class="col-xl-6">
                        <button type="button" class="btn btn-primary link-to-login">
                            <span *ngIf="!isLoadingForm" (click)="loginAction()">Đăng nhập</span>
                            <loading-page *ngIf="isLoadingForm"></loading-page>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="home-page__float footer-part">
        <div class="logo-title">
            <div class="logo">
                <img alt="" src="./assets/media/client-logos/quoc-huy.png">
            </div>
            <div class="title">
                <span>CỔNG ĐĂNG NHẬP TẬP TRUNG</span>
                <span>BỘ GIÁO DỤC ĐÀO TẠO</span>
            </div>
        </div>
        <div class="address">
            <div class="address__wrapper">
                <span>Địa chỉ: <b>Số 35 Đại Cồ Việt, Hà Nội</b></span>
                <span>Điện thoại: <b>024.38695144; Fax: 024.38694085</b></span>
                <span>Email: <b>bogddt@moet.gov.vn</b></span>
            </div>
        </div>
    </div>
</div>